import React from 'react';
import { Oval } from 'react-loader-spinner';

function Loading({ backgroundColor, spinnerColor }) {
    return (
        <div
            style={{
                backgroundColor: backgroundColor,
                width: '100%',
                height: '100vh',
                display: 'flex',
                justifyContent: 'center',
                alignItems: 'center',
            }}
        >
            <Oval
                visible={true}
                height="50"
                width="50"
                color={spinnerColor}
                secondaryColor="#fffff"
                ariaLabel="oval-loading"
                wrapperStyle={{}}
                wrapperClass=""
            />
        </div>
    );
}

export default Loading;
